export default __webpack_public_path__ + "static/media/air-icon.6ce9fe78.svg";